import React from "react";
import FormViewer from "../../FormViewer";
import Modal from "../../Modal";


class MatrixModal extends React.Component {
    state = {
        Storages: [
            { icon: "/assets/icons/uploadmodal/paperclip.svg", title: "My Device" },
            { icon: "/assets/icons/uploadmodal/link.svg", title: "Link (URL)" },
            { icon: "/assets/icons/uploadmodal/googledrive.svg", title: "Google Drive" },
            { icon: "/assets/icons/uploadmodal/onedrive.svg", title: "One Drive" },
            { icon: "/assets/icons/uploadmodal/dropbox.svg", title: "DropBox" },
        ],

        header: [
            { key: 'Name', type: 'TextInput', col: '12', information: { label: '{{lang}}Name', placeholder: 'Start typing...', required: true } },
            // { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
            // { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
            // { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
        ],

        header2: [
            { key: 'assignee', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'Hossein Mohseni', value: 'Equal' }, { title: 'Pouya Pezhman', value: 'Equal' }], label: '{{lang}}Assignee', placeholder: 'Select a User', required: true } },
            { key: 'staus', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'Todo', value: 'Equal' }, { title: 'In Progress', value: 'Equal' }], label: '{{lang}}Status', placeholder: 'Find an Option', required: true } },
            { key: 'Note', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Note', placeholder: 'White here', required: true } },
        ],
    }


    render() {
        return (

            <Modal height={"100%"} ref={el => this.modal = el}>
                <div className="w-100 br-10 p-3" style={{ backgroundColor: "#f6f6f6", overflow: "hidden", height: "380px" }} >
                    <div className="pb-2" style={{ borderBottom: "1px solid #eee" }}>
                        <div>
                            <p className="font-size-12" style={{ color: "#555" }}>Unnamed record</p>
                            <p className="font-size-10" style={{ color: "#777" }}>Record from Table 1</p>
                        </div>
                        <div>

                        </div>
                    </div>
                    <div className="pt-2" style={{ borderBottom: "1px solid #eee" }}>
                        <div >
                            <FormViewer ref={el => this.form = el} headers={this.state.header} theme={"modern"} inputClass={"modern-input"} />
                        </div>
                    </div>
                    <div >
                        <FormViewer ref={el => this.form = el} headers={this.state.header2} theme={"modern"} inputClass={"modern-input"} />
                    </div>
                </div>
            </Modal>
        );

    }
}


export default MatrixModal;
